import { render, staticRenderFns } from "./PlayerControls.vue?vue&type=template&id=2f84a1a6&scoped=true&"
import script from "./PlayerControls.vue?vue&type=script&lang=js&"
export * from "./PlayerControls.vue?vue&type=script&lang=js&"
import style0 from "./PlayerControls.vue?vue&type=style&index=0&id=2f84a1a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f84a1a6",
  null
  
)

export default component.exports